var _defs, _rect, _circle, _circle2, _g, _circle3, _circle4, _text, _text2, _text3, _rect2, _circle5, _circle6, _path, _text4, _text5, _rect3, _circle7, _circle8, _circle9, _circle0, _path2, _text6, _text7, _rect4, _circle1, _ellipse, _path3, _text8, _text9, _rect5, _circle10, _path4, _text0, _text1, _rect6, _circle11, _text10, _text11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentHeroOperatingSystemMapMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 620,
    height: 820,
    viewBox: "0 0 620 820",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Custom development mobile operating system map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-card",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07152A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020716"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "system-glow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 14,
    floodColor: "#087CFF",
    floodOpacity: 0.35
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 560,
    height: 780,
    rx: 38,
    fill: "url(#system-card)",
    stroke: "#254463",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 342,
    r: 190,
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.26
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 342,
    r: 144,
    fill: "none",
    stroke: "#FF2775",
    strokeOpacity: 0.2,
    strokeDasharray: "8 11"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#5DB3FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeDasharray: "5 8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177 158L310 342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 158L310 342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 543L310 342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 543L310 342"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 342,
    r: 92,
    fill: "#071D39",
    stroke: "#087CFF",
    strokeWidth: 3,
    filter: "url(#system-glow)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 342,
    r: 72,
    fill: "#08152B",
    stroke: "#FF2775",
    strokeOpacity: 0.45
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 328,
    fill: "#78C2FF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    textAnchor: "middle",
    fontWeight: 800,
    letterSpacing: 2
  }, "YOUR")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 360,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 25,
    textAnchor: "middle",
    fontWeight: 850
  }, "OPERATION")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 386,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    textAnchor: "middle",
    fontWeight: 650
  }, "ONE CONNECTED SYSTEM")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 110,
    width: 210,
    height: 96,
    rx: 19,
    fill: "#0B2341",
    stroke: "#087CFF",
    strokeOpacity: 0.65
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 158,
    r: 25,
    fill: "#087CFF",
    fillOpacity: 0.11
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 151,
    r: 8,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 172c2-10 7-14 14-14s12 4 14 14",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 149,
    y: 153,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "PEOPLE")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 149,
    y: 174,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 630
  }, "Roles and responsibility")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 110,
    width: 210,
    height: 96,
    rx: 19,
    fill: "#0B2341",
    stroke: "#FF2775",
    strokeOpacity: 0.65
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 158,
    r: 25,
    fill: "#FF2775",
    fillOpacity: 0.11
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 158,
    r: 5,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 391,
    cy: 147,
    r: 5,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 391,
    cy: 170,
    r: 5,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M370 158h10l7-8M380 159l7 8",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 415,
    y: 153,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "PROCESS")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 415,
    y: 174,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 630
  }, "Work and handovers")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 495,
    width: 210,
    height: 96,
    rx: 19,
    fill: "#0B2341",
    stroke: "#30D6A1",
    strokeOpacity: 0.65
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 543,
    r: 25,
    fill: "#30D6A1",
    fillOpacity: 0.11
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 112,
    cy: 532,
    rx: 15,
    ry: 6,
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97 532v22c0 3 7 6 15 6s15-3 15-6v-22M97 543c0 3 7 6 15 6s15-3 15-6",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 149,
    y: 538,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "DATA")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 149,
    y: 559,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 630
  }, "Evidence and context")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 495,
    width: 210,
    height: 96,
    rx: 19,
    fill: "#0B2341",
    stroke: "#F5B642",
    strokeOpacity: 0.65
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 543,
    r: 25,
    fill: "#F5B642",
    fillOpacity: 0.11
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M361 553l9-9 8 6 16-20M386 530h8v8",
    fill: "none",
    stroke: "#F5B642",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 415,
    y: 538,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "DECISIONS")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 415,
    y: 559,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 630
  }, "Human-owned action")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 684,
    width: 444,
    height: 70,
    rx: 18,
    fill: "#0B2341",
    stroke: "#2A4B6B"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 719,
    r: 6,
    fill: "#30D6A1"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 136,
    y: 714,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820
  }, "MEASURABLE BUSINESS OUTCOME")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 136,
    y: 734,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 9,
    fontWeight: 620
  }, "Productivity \xB7 visibility \xB7 accountable decisions")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentHeroOperatingSystemMapMobile);
export default __webpack_public_path__ + "static/media/custom-development-hero-operating-system-map-mobile.8510184e414382530700a8270c8f1f3f.svg";
export { ForwardRef as ReactComponent };